import React from 'react';
import { WhatsAppButton } from './WhatsAppButton';
export function ContactSection() {
  return <section className="py-20 bg-gray-50" data-id="element-15">
      <div className="container mx-auto px-4" data-id="element-16">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-17">
          <span className="inline-block px-4 py-1.5 rounded-full bg-lightBg text-primary font-semibold text-sm mb-4" data-id="element-18">
            Contacto directo
          </span>
          <h2 className="text-gray-900 font-heading font-bold mb-4" data-id="element-19">
            Agendá una inspección técnica hoy mismo
          </h2>
          <p className="text-gray-600 text-lg" data-id="element-20">
            Hablá directo con nuestros especialistas. Sin formularios ni
            esperas. Respuesta inmediata por WhatsApp.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-21">
          {/* Tarjeta 1 - Ramón */}
          <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 flex flex-col items-center text-center hover:shadow-md transition-shadow" data-id="element-22">
            <div className="w-20 h-20 rounded-full bg-primary text-accent flex items-center justify-center text-2xl font-bold font-heading mb-4" data-id="element-23">
              RA
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-1 font-heading" data-id="element-24">
              Ramón A. Obregón
            </h3>
            <p className="text-gray-500 font-medium mb-6" data-id="element-25">
              Especialista técnico — 11 6127-9601
            </p>
            <WhatsAppButton href="https://wa.me/5491161279601?text=Hola%20Ramón%2C%20quiero%20agendar%20una%20inspección%20técnica%20para%20mi%20equipo" text="Escribir a Ramón" variant="primary" className="w-full" data-id="element-26" />
          </div>

          {/* Tarjeta 2 - Marcelo */}
          <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 flex flex-col items-center text-center hover:shadow-md transition-shadow" data-id="element-27">
            <div className="w-20 h-20 rounded-full bg-avatar text-accent flex items-center justify-center text-2xl font-bold font-heading mb-4" data-id="element-28">
              MA
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-1 font-heading" data-id="element-29">
              Marcelo Aguirre
            </h3>
            <p className="text-gray-500 font-medium mb-6" data-id="element-30">
              Especialista técnico — 11 2170-7246
            </p>
            <WhatsAppButton href="https://wa.me/5491121707246?text=Hola%20Marcelo%2C%20quiero%20agendar%20una%20inspección%20técnica%20para%20mi%20equipo" text="Escribir a Marcelo" variant="secondary" className="w-full" data-id="element-31" />
          </div>
        </div>
      </div>
    </section>;
}